module.exports = __webpack_public_path__ + "img/otp.d9a20ceb.jpg";